import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import backendUrl from '../../apiConfig';

export default function AddLinks() {
    const navigate = useNavigate();
    const [links, setLinks] = useState([
        { title: '', url: '' },
        { title: '', url: '' },
        { title: '', url: '' }
    ]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleLinkChange = (index, key, value) => {
        const newLinks = [...links];
        newLinks[index][key] = value;
        setLinks(newLinks);
    };

    const addLink = useCallback(async () => {
        const validLinks = links.filter(link => link.title.trim() && link.url.trim());

        if (validLinks.length === 0) {
            setError("Please enter at least one link with a Title and URL.");
            return;
        }

        setLoading(true);
        const token = localStorage.getItem("jwtToken");

        try {
            await Promise.all(validLinks.map(link =>
                axios.post(
                    `${backendUrl}/links/add`,
                    { title: link.title, url: link.url },
                    { headers: { Authorization: `Bearer ${token}` } }
                )
            ));
            setError(null);
            navigate("/profileDetails"); // Navigate after successful submission
        } catch (error) {
            console.error("Error adding links:", error);
            setError("Failed to add links. Try again.");
        } finally {
            setLoading(false);
        }
    }, [links, navigate]);

    const handleSkip = () => {
        navigate("/profileDetails");
    };

    return (
        <div className="min-h-screen bg-white text-black">
            <div className="fixed top-0 left-0 right-0 h-1 bg-gray-100">
                <div className="h-full bg-purple-500 w-2/4" />
            </div>

            <div className="fixed top-4 left-4 right-4 flex justify-between">
                <button
                    onClick={() => navigate(-1)}
                    className="text-sm text-gray-500 hover:text-gray-900"
                >
                    Back
                </button>
                <button
                    onClick={handleSkip}
                    className="text-sm text-gray-500 hover:text-gray-900"
                >
                    Skip
                </button>
            </div>

            <div className="max-w-xl mx-auto px-4 py-16">
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold mb-4">Add your links</h1>
                    <p className="text-gray-600">
                        Complete the fields below to add your content to your new Linktree.
                    </p>
                </div>

                <div className="space-y-8">
                    {links.map((link, index) => (
                        <div key={index} className="flex flex-col space-y-2">
                            <input
                                type="text"
                                placeholder="Title"
                                value={link.title}
                                onChange={(e) => handleLinkChange(index, 'title', e.target.value)}
                                className="p-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                            />
                            <input
                                type="url"
                                placeholder="Website URL"
                                value={link.url}
                                onChange={(e) => handleLinkChange(index, 'url', e.target.value)}
                                className="p-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                            />
                        </div>
                    ))}
                </div>

                {error && <p className="text-red-500 text-center mt-4">{error}</p>}

                <button
                    onClick={addLink}
                    disabled={loading}
                    className="w-full mt-8 bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-full font-medium transition-colors"
                >
                    {loading ? 'Loading...' : 'Continue'}
                </button>
            </div>
        </div>
    );
}
